import React from 'react';
import classNames from 'classnames';

import { WysiwygField, FormattedLink } from '../../../components';

import './style.scss';

const ParagraphText = ({ entity, className }) => {
  const highlight = entity.getIn(['field_highlight_paragraph', 0, 'value']);
  const link = entity.get('field_link');

  return (
    <div className={classNames('Paragraph ParagraphText', className, highlight ? 'u-padding--7 o-background--grey' : null)}>
      <h2 className={classNames('ParagraphText__title', highlight ? 'h3' : null)}>
        {entity.getIn(['field_title', 0, 'value'])}
      </h2>
      <WysiwygField
        property="schema:text"
        className="ParagraphText__text"
        html={entity.getIn(['field_text', 0, 'processed'])}
      />
      <FormattedLink link={link} />
    </div>
  );
};

export default ParagraphText;
